import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function BankIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M2.42675 8.84583C2.16208 9.00384 2 9.28938 2 9.59763C2 10.0812 2.39202 10.4732 2.8756 10.4732H3V20.9999C3 21.5522 3.44772 21.9999 4 21.9999H20C20.5523 21.9999 21 21.5522 21 20.9999V10.4732H21.131C21.611 10.4732 22 10.0842 22 9.60427C22 9.29277 21.8333 9.0051 21.563 8.85026L12.1217 3.44204C11.9187 3.32576 11.6688 3.32801 11.4679 3.44794L2.42675 8.84583ZM11 8C11 7.44771 11.4477 7 12 7C12.5523 7 13 7.44771 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8ZM11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13ZM7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15V18C9 18.5523 8.55228 19 8 19C7.44772 19 7 18.5523 7 18V15ZM16 14C15.4477 14 15 14.4477 15 15V18C15 18.5523 15.4477 19 16 19C16.5523 19 17 18.5523 17 18V15C17 14.4477 16.5523 14 16 14Z" fill={props.fill} />
			<circle opacity="0.5" cx="20" cy="4" r="1" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<BankIcon fill={props.fill} />
		</div>
	);
}